import { PaymentItem } from "./payment-item";
import { Shift } from "./shift";

export class Payment {
    id!: number;
    organization_id!: number;
    created_by_contact_id!: number;
    created_at!: Date;
    updated_at!: Date;
    customer_contact_id!: number;
    type!: string;
    status!: string;
    api_status!: string;
    shift_id!: number;
    payment_id!: string;
    currency!: string;
    amount!: number;
    transaction_id!: string;
    error_message!: string;
    redirect_url!: string;
    shift: Shift = new Shift();
    result_code!: string;
    items: PaymentItem[] = []
    receipt_number!: number
}
